import { OVERVIEW_TOOLS } from "./products";
import { ToolCardGrid } from "./ToolCard";

export default function AudiolabSection() {
  return (
    <section className="bg-white px-[6vw] pb-[105px] pt-24 text-marketing-ink max-[680px]:px-5 max-[680px]:py-[76px]">
      <div className="mx-auto w-[min(1180px,100%)]">
        <div className="max-w-[980px]">
          <p className="mb-7 w-fit -rotate-1 rounded-full border border-[rgba(37,217,207,0.2)] bg-[rgba(223,255,252,0.86)] px-[18px] py-[10px] font-permanent-marker text-[28px] uppercase leading-[1.1] tracking-[0.01em] text-[#0C9F96] shadow-[0_10px_28px_rgba(37,217,207,0.16)] max-[680px]:mb-[22px] max-[680px]:px-[14px] max-[680px]:py-2">
            Audiolab
            <sup className="relative -top-[0.38em] ml-1 font-figtree text-[0.42em] font-bold leading-none">
              ®
            </sup>
          </p>
          <h2 className="m-0 max-w-[920px] font-figtree text-[clamp(42px,5vw,68px)] font-black uppercase leading-[1.02] tracking-[-0.045em] [text-wrap:balance] max-[680px]:text-[clamp(40px,12vw,52px)]">
            Your new workflow:
            <span className="block whitespace-nowrap text-blue-600">
              Just upload.
            </span>
          </h2>
          <p className="mt-7 max-w-[720px] font-open-sans text-[19px] leading-[1.65] text-marketing-muted max-[680px]:mt-[22px] max-[680px]:text-[17px]">
            Put your non-creative work on autopilot. Lutely handles the tasks
            that make your music ready for distribution, even when session files
            are long gone. Every track you upload comes with a complete asset
            package, ready to use on Lutely or wherever your music needs to go.
          </p>
        </div>
        <ToolCardGrid
          products={OVERVIEW_TOOLS}
          className="mt-24 max-[680px]:mt-[72px]"
        />
      </div>
    </section>
  );
}
